import axios from "axios";
import { OverrideDate, ProductionSiteCalendar } from "../models/ProductionSiteCalendarModel";
import { getConfig } from "../../modules/Config/Config";

async function getProductionSiteCalendar(plantCode: string): Promise<ProductionSiteCalendar> {
  const backendConfig = await getConfig("backend");

  return axios
    .get<ProductionSiteCalendar>(`${backendConfig.url}/calendar/${plantCode}/calendar`,
      {
        headers:
        {
          "Content-Type": "application/json",
        }
      })
    .then((response) => {
      return {
        ...response.data,
        overrideDates: response.data.overrideDates.map((overrideDate) => {
          return {
            ...overrideDate,
            date: overrideDate.date, // Comes in as YYYY-MM-DD
          };
        })
      }
    });
}

async function putProductionSiteWeekDays(plantCode: string, weekdays: string[]): Promise<any> {
  const backendConfig = await getConfig("backend");

  return axios
    .put<any>(`${backendConfig.url}/calendar/${plantCode}/productionweekdays`,
      weekdays,
      {
        headers:
        {
          "Content-Type": "application/json",
        }
      });
}

async function putProductionSiteOverride(plantCode: string, overrideDate: OverrideDate): Promise<any> {
  const backendConfig = await getConfig("backend");

  return axios
    .put<any>(`${backendConfig.url}/calendar/${plantCode}/overridedate`,
      overrideDate,
      {
        headers:
        {
          "Content-Type": "application/json",
        }
      });
}

async function deleteProductionSiteOverride(plantCode: string, date: string): Promise<any> {
  const backendConfig = await getConfig("backend");

  return axios
    .delete<any>(`${backendConfig.url}/calendar/${plantCode}/overridedate?date=${date}`,
      {
        headers:
        {
          "Content-Type": "application/json",
        }
      });
}

export { getProductionSiteCalendar, putProductionSiteWeekDays, putProductionSiteOverride, deleteProductionSiteOverride };
